export const displayLoadingActon = {type:'DISPLAY_LOADING'};
export const hideLoadingActon = {type:'HIDE_LOADING'};